import Heading from '../../sharedComponents/Heading/Heading';
import './Contact.scss';
import paperclip from '../../../assets/icons/paperclip.svg';
import Input from '../../sharedComponents/Input/Input';
import Button from '../../sharedComponents/Button/Button';
import { useEffect, useState } from 'react';
import { useEmailJS } from '../../coreModules/hooks/useEmaiJs';
function Contact() {
  const INITIAL_FORM_DATA = {
    name: '',
    email: '',
    subject: '',
    message: ''
  }
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errorData, setErrorData] = useState(INITIAL_FORM_DATA);
  const [isBtnDisabled, setBtnDisabled] = useState(true);

  const handleInputChange = (key: string, value: string) => {
    if (value === '') {
      setErrorData((prevState) => ({
        ...prevState,
        [key]: `Enter value for ${key}`
      }))
    }
    else {
      setErrorData((prevState) => ({
        ...prevState,
        [key]: ``
      }))
    }
    const newFormData = {
      ...formData,
      [key]: value

    }
    setFormData(newFormData);
    const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newFormData?.email?.trim());
    const isValidName = /^[a-zA-Z\s]{2,50}$/.test(newFormData?.name?.trim());
    const isValidSubject = /^.{5,100}$/.test(newFormData?.subject?.trim());
    const isValidMessage = /^.{5,1000}$/.test(newFormData?.message?.trim());
    if (!isValidName) {
      setErrorData((prevState) => ({
        ...prevState,
        name: 'Enter valid name'
      }))
    }
    if (!isValidEmail) {
      setErrorData((prevState) => ({
        ...prevState,
        email: 'Enter valid email address'
      }))
    }
    if (!isValidSubject) {
      setErrorData((prevState) => ({
        ...prevState,
        subject: 'Enter valid subject'
      }))
    }
    if (!isValidMessage) {
      setErrorData((prevState) => ({
        ...prevState,
        message: 'Enter valid message'
      }))
    }
    if (isValidName && isValidEmail && isValidSubject && isValidMessage) {
      setBtnDisabled(false);
    }
  }

  const { isLoading, error, sendEmail, success } = useEmailJS({
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID_CONTACT!,
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT!,
    publicKey: process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY!,
    formData,
  });


  const handleSubmit = async () => {
    const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email?.trim());
    const isValidName = /^[a-zA-Z\s]{2,50}$/.test(formData.name?.trim());
    const isValidSubject = /^.{5,100}$/.test(formData.subject?.trim());
    const isValidMessage = /^.{5,1000}$/.test(formData.message?.trim());

    if (isValidName && isValidEmail && isValidSubject && isValidMessage) {
      setBtnDisabled(false);
      try {
        await sendEmail();
      } catch (error) {
        console.error('Error sending email:', error);
      }
    }
  };

  useEffect(() => {
    if(success){
      window.alert('Mail Sent Successfully!');
      setFormData(INITIAL_FORM_DATA);
      setErrorData(INITIAL_FORM_DATA);
    }
  }, [success])

  return (
    <div id='alpha-perceptron-contact' className='alpha-perceptron-contact'>
      <div className='alpha-perceptron-contact__section-one'>
        <div className='alpha-perceptron-contact__section-one__left-content'>
          <Heading size='h2' theme='light' type='primary'>Let's Talk</Heading>
          <Heading size='h6' theme='light' type='secondary'>
            We’d love to hear from you! Please fill out the form or reach us through the following methods.
          </Heading>
          <div className='alpha-perceptron-contact__section-one__left-content__contact-details'>
            <div className='alpha-perceptron-contact__section-one__left-content__contact-details__item'>
              <img className='alpha-perceptron-contact__section-one__left-content__contact-details__item__icon' src={paperclip} alt='contact' />
              <Heading size='h6' type='primary' theme='light'>contact@alphaperceptron.com</Heading>
            </div>
          </div>
        </div>
        <div className='alpha-perceptron-contact__section-one__right-content'>
          <div className='alpha-perceptron-contact__section-one__right-content__form-container'>
            <Input
              value={formData?.name}
              theme='light'
              type="text"
              placeholder="Your name"
              fullWidth
              onChange={(e) => handleInputChange('name', e.target.value)}
              helperText={errorData?.name}
            />
            <Input
              value={formData?.email}
              theme='light'
              type="email"
              placeholder="Your email"
              fullWidth
              onChange={(e) => handleInputChange('email', e.target.value)}
              helperText={errorData?.email}

            />
            <Input
              value={formData?.subject}
              theme='light'
              type="text"
              placeholder="Subject"
              fullWidth
              onChange={(e) => handleInputChange('subject', e.target.value)}
              helperText={errorData?.subject}

            />
            <Input
              value={formData?.message}
              theme='light'
              type="textarea"
              placeholder="Message"
              fullWidth
              onChange={(e) => handleInputChange('message', e.target.value)}
              helperText={errorData?.message}
            />
            <Button disabled={isBtnDisabled} type='secondary' theme='light' fullWidth onClick={handleSubmit}>{isLoading ? 'Sending...' : 'Send Message'}</Button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <Heading type='secondary' theme='light' size='h7'>We will reply within 24 hours</Heading>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;

